import React, { useState, useEffect } from "react";
import { Container } from "components";
import Footer from "components/footer";
import api from "services/api";
import { useNavigate } from "react-router-dom";

const MemebershipsList = () => {
  const [showMembership] = useState(false);
  const [memberships, setMemberships] = useState([]);
  const navigate = useNavigate();

  const fetchMembershipData = async () => {
    try {
      const response = await api.get("/membership-application");
      setMemberships(response.data.data.memberApplication);
    } catch (error) {
      console.log("membershipList error:", error);
    }
  };

  useEffect(() => {
    fetchMembershipData();
  }, []);

  return (
    <Container>
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <ul className="nav nav-pills flex-column flex-md-row mb-4">
            <li className="nav-item">
              <h4 className={`py-2 mb-2`}>
                {!showMembership ? "Membership" : "Membership Details"}
              </h4>
            </li>
          </ul>
          <div class="card-datatable table-responsive">
            <table class="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
              <thead>
                <tr>
                  <th>FirstName</th>
                  <th>LastName</th>
                  <th class="text-truncate">Relation</th>
                  <th class="text-truncate">Status</th>
                  <th>PLAN</th>
                  <th>APPLICATION NUMBER</th>
                  <th class="text-truncate">Valid Till</th>
                  <th class="cell-fit">Actions</th>
                  {/* <th class="cell-fit">Add Member</th> */}
                </tr>
              </thead>
              <tbody>
                {memberships.map((res, index) => {
                  return (
                    <tr key={index}>
                      <td>{res.first_name}</td>
                      <td>{res.last_name}</td>
                      <td>{res.relation}</td>
                      <td>
                        <span
                          className={`badge ${res.status === "Pending"
                              ? "bg-warning"
                              : res.status === "Approved"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                        >
                          {res.status}
                        </span>
                      </td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: res.membership_plan.title,
                        }}
                      />
                      <td>{res.application_no}</td>
                      <td>{res.end_date}</td>
                      <td>
                        <button
                          variant="outlined"
                          className="btn btn-primary me-2"
                          onClick={() =>
                            navigate(`/membershipDetails/${res.application_no}`)
                          }
                        >
                          View
                        </button>
                      </td>
                      {/* <td>
                        <FontAwesomeIcon icon={faPlus} size="lg" />
                      </td> */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* <div class="card-datatable table-responsive">
            <table class="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
              <thead>
                <tr>
                  <th>FirstName</th>
                  <th>LastName</th>
                  <th class="text-truncate">Relation</th>
                  <th class="text-truncate">Status</th>
                  <th>PLAN</th>
                  <th>APPLICATION NUMBER</th>
                  <th class="text-truncate">Valid Till</th>
                  <th class="cell-fit">Actions</th>
                  <th class="cell-fit">Add Member</th>

                </tr>
              </thead>
              <tbody>
                
                    <tr>
                      <td>sia</td>
                      <td>gayj</td>
                      <td>self</td>
                      <td>
                        <span 
                        >
                          Approved
                        </span>
                      </td>
                      <td>Dash Bondho</td>
                      <td>ADETHD1258</td>
                      <td>12/05/2024</td>
                      <td>
                        
                        <button
                          variant="outlined"
                          className="btn btn-primary me-2"                        
                        >
                          View
                        </button>


                      </td>
                      <td>
                        <FontAwesomeIcon icon={faPlus} size="lg" />
                      </td>
                    </tr>
               
              </tbody>
            </table>
          </div> */}
        </div>
        <Footer />
        <div class="content-backdrop fade"></div>
      </div>
    </Container>
  );
};

export default MemebershipsList;
